module.exports = __webpack_public_path__ + "static/media/credit-card_jcb.2157d4bd.svg";